// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1aD4U","emails":"CreateEditClinics_emails__2rPNU","emailTagLabel":"CreateEditClinics_emailTagLabel__34pgp"};